import { createContext } from 'react'

interface AssistantPanelContextInfo {
  /** If undefined, no UI affordance is provided to close the assistant */
  closeAssistantPanel?: () => void
}

/**
 * Note this context is expected to not be provided in certain scenarios, and its absence indicates that we're not
 * within the agent panel (i.e. the <Assistant /> component). Logic should handle that case gracefully.
 *
 * @deprecated Use the `useAgentContext()` from `@grammarly/assistant-core` instead.
 */
export const AssistantPanelContext = createContext<AssistantPanelContextInfo>({})
